import React from "react";

import { TextInput, Text } from "../../atoms";

export const LocationInput = props => {
	const { values, errors, handleChange, name, label, isRegistration } = props;

	return (
		<div className="location-input flex -v text-input">
			<span className="label">{label}:</span>
			{ isRegistration
				?
				<div>
					<div className="input-area flex -al-c">
						<TextInput
							id="street"
							type="text"
							className="text-input street"
							label="Endereço"
							value={values["street"]}
							changeAction={handleChange}
							name={name}
							/>
						<TextInput
							id="num"
							type="text"
							className="text-input num"
							label="Número"
							value={values["num"]}
							changeAction={handleChange}
							name={name}
							/>
					</div>
					<div className="input-area flex -al-c">
						<TextInput
							id="compl"
							type="text"
							className="text-input compl"
							label="Complemento"
							value={values["compl"]}
							changeAction={handleChange}
							name={name}
							/>
					</div>
				</div>
				: ''
			}
			<div className="input-area flex -al-c">
				<TextInput
					id="country"
					type="text"
					className="mini-input country"
					label="País"
					value={values["country"]}
					changeAction={handleChange}
					name={name}
				/>
				<TextInput
					id="state"
					type="text"
					className="mini-input state"
					label="UF"
					value={values["state"]}
					changeAction={handleChange}
					name={name}
				/>
				{ isRegistration
					?
					<TextInput
						id="city"
						type="text"
						className="mini-input city"
						label="Cidade"
						value={values["city"]}
						changeAction={handleChange}
						name={name}
						/>
					: ''
				}
			</div>
		</div>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/LocationInput.js